import { Component } from '@angular/core';
import { MetricBaseAbstract } from '../metric-base.abstract';

@Component({
    selector: 'app-ga-metric',
    templateUrl: './ga-metric.component.html',
    standalone: true
})
export class GaMetricComponent extends MetricBaseAbstract {
  constructor() {super()}

  protected override onRunMetric(codes: string[]): void {
    this.runGA(codes);
  }

  private runGA(codes: string[]): void {
    this.insertGA().then(ga => {
      codes.forEach(code => {
        ga('create', code, 'auto');
      });
      ga('send', 'pageview');
    })
  }

  private insertGA(): Promise<any> {
    (window as any).ga = (window as any).ga || function() {((window as any).ga.q = (window as any).ga.q || []).push(arguments)}; (window as any).ga.l =+ new Date;
    return this.loadScript('https://www.google-analytics.com/analytics.js').then(() => {
      return (window as any).ga
    });
  }
}
